import styled from "styled-components";
import { Modal, NewButton } from "@bca/ui-library";

import theme from "../../styles/theme";

export const StyledModal = styled(Modal)`
  width: ${(props) => (props.isMobile ? "22.188rem" : "31.938rem")};
`;

export const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 3.25rem;
`;

export const ModalTitle = styled.div`
  margin-top: 0.5rem;
  font-weight: 700;
  font-size: 1.25rem;
  text-align: center;
`;

export const StyledModalText = styled.div`
  font-size: 0.875rem;
  text-align: center;
  margin-top: 1.188rem;
  color: ${theme.color.gray};
`;

export const StyledNewButton = styled(NewButton)`
  margin-top: 3.25rem;
  width: ${(props) => (props.isMobile ? "8.18rem" : "11.43rem")};
`;

export const StyledLink = styled.a`
  text-decoration: none;
`;
